import React, { useState } from 'react';
import { RouteProp, useNavigation, useRoute } from '../../navigation/native';
import { KeyboardAvoidingView, Platform, ScrollView, View } from '../../web/react-native';
import { useDispatch } from 'react-redux';
import styled from '../../components/styled';

import { AppDispatch } from '../../store/store';
import { NavBar, NavTextButton, LoadingOverlay, RichTextField } from '../../components';
import { selectEditedSnippets, selectIsLogDetailLoading, shiftLogActions } from '../../store';
import { displayConfirmationAlert, displayInformationAlert } from '../../helpers/Functions';
import { RootStackParamList } from '../../app/Navigation';

const PostCommentScreen = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigation = useNavigation();
  const { params } = useRoute<RouteProp<RootStackParamList, 'EditingRowScreen'>>();

  const isLoading = selectIsLogDetailLoading.useHook();
  const snippet = selectEditedSnippets.useHook();

  const [comments, setComments] = useState('');

  const rowData = snippet.data[params.rollupIndex ?? 0].rowData[params.rowIndex];

  const handleCancelPressed = () => {
    if (comments.length === 0) {
      navigation.goBack();
    } else {
      displayConfirmationAlert({
        title: 'Confirm Cancel',
        description:
          'Are you sure you want leave? Any changes to the standing order comment will be lost.',
        onConfirm: () => {
          navigation.goBack();
        },
      });
    }
  };
  const handlePostPressed = () => {
    switch (snippet.type) {
      case 'StandingOrder':
        dispatch(
          shiftLogActions.postStandingOrderComment({
            standingOrderId: rowData.standingOrderId as string,
            comment: comments,
          }),
        )
          .unwrap()
          .then(() =>
            displayInformationAlert({
              title: 'Successfully Posted Comment',
              description: 'The standing order comment has been successfully posted.',
              onOk: () => {
                navigation.goBack();
              },
            }),
          )
          .catch(() => { });
        break;
      case 'Task':
        dispatch(
          shiftLogActions.postTaskComment({
            taskId: rowData.taskId as string,
            comment: comments,
          }),
        )
          .unwrap()
          .then(() =>
            displayInformationAlert({
              title: 'Successfully Posted Comment',
              description: 'The task comment has been successfully posted.',
              onOk: () => {
                navigation.goBack();
              },
            }),
          )
          .catch(() => { });

        break;
    }
  };

  return (
    <>
      <NavBar
        title={snippet.type === 'StandingOrder' ? 'Standing Order' : 'Task'}
        leftButton={<NavTextButton text="Cancel" onPress={handleCancelPressed} />}
        rightButton={
          <NavTextButton text="Post" onPress={handlePostPressed} disabled={comments.length === 0} />
        }
      />
      <LoadingOverlay visible={isLoading} />
      <SafeAreaView>
        <KeyboardAvoidingView
          style={{ flex: 1 }}
          behavior={Platform.OS === 'ios' ? 'padding' : undefined}
          enabled
          keyboardVerticalOffset={100}>
          <ScrollView>
            <Description>Comment</Description>
            <TextInput
              autoFocus={true}
              placeholder="Please enter any comments"
              onChangeText={setComments}
            />
          </ScrollView>
        </KeyboardAvoidingView>
      </SafeAreaView>
    </>
  );
};

export default PostCommentScreen;

const SafeAreaView = styled.SafeAreaView`
  flex: 1;
  margin: 10px;
  min-height: 10px;
`;

const Description = styled.Text`
  margin-top: 10px;
  font-weight: 500;
  margin-bottom: 7px;
`;

const TextInput = styled(RichTextField)`
  min-height: 200px;
`;